export enum OrderStatus {
  orderPlaced = 'orderPlaced',
  paymentReceived = 'paymentReceived',
  sampleReceived = 'sampleReceived',
  resultsReady = 'resultsReady',
  reviewReady = 'reviewReady',
  releaseReady = 'releaseReady',
}
